import { EQUITY_COMPANIES } from "../../../actions/types";
const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case EQUITY_COMPANIES:
      return {
        ...state,
        items: action.payload
      };

    default:
      return state;
  }
}
